// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import "@/polyfills";
// Notifications plugin. Used on Notifications page
import Notifications from "@/components/NotificationPlugin";
// Validation plugin used to validate forms
import { configure } from "vee-validate";
// Sweetalert2 plugin.
import VueSweetalert2 from "vue-sweetalert2";
// Async computed plugin.
import AsyncComputed from "vue-async-computed";
// A plugin file where you could register global components used across the app
import GlobalComponents from "./globalComponents";
// A plugin file where you could register global directives
import GlobalDirectives from "./globalDirectives";
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from "@/components/SidebarPlugin";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

// vue-lodash
import VueLodash from "vue-lodash";
import lodash from "lodash";

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// asset imports
import "@/assets/sass/theme/theme.scss";
import "@/assets/css/nucleo/css/nucleo.css";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { messages } from "vee-validate/dist/locale/en.json";
import "sweetalert2/dist/sweetalert2.min.css";

messages.confirmed = "The {_field_} field does not match";

extend("email_domain", (value) => {
	const regex = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;

	return false !== regex.test(value) ? true : false;
});

Object.keys(rules).forEach((rule) => {
	extend(rule, {
		...rules[rule], // copies rule configuration
		message: messages[rule], // assign message
	});
});

export default {
	install(Vue) {
		Vue.use(GlobalComponents);
		Vue.use(GlobalDirectives);
		Vue.use(SideBar);
		Vue.use(Notifications);
		Vue.use(VueLodash, {
			lodash: lodash,
		});
		Vue.use(BootstrapVue);
		Vue.use(IconsPlugin);
		Vue.use(VueSweetalert2, {
			toast: true,
			showCancelButton: true,
			confirmButtonClass:
				"btn btn-md btn-primary font-weight-normal mx-1",
			cancelButtonClass:
				"btn btn-md btn-white font-weight-normal mx-1 shadow-none",
			buttonsStyling: false,
			allowOutsideClick: false,
		});
		Vue.use(AsyncComputed);
		configure({
			classes: {
				valid: "is-valid",
				invalid: "is-invalid",
				dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
			},
		});
	},
};
